import axios from 'axios';
import api from '@/api/api';

const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  clientes: [],
  clienteEnderecos: [],
  clienteTelefones: [],
  clienteEmails: [],
  clienteTags: [],
  clienteProjetos: []
};

const getters = {
  // Clientes
  clientes: state => state.clientes.sort((a,b) => a.Fantasia > b.Fantasia ? 1 : -1),
  clientesAtivo: state => state.clientes.filter(c => c.Status.startsWith('A')).sort((a,b) => a.Fantasia > b.Fantasia ? 1 : -1),
  clienteEnderecos: state => state.clienteEnderecos,
  clienteTelefones: state => state.clienteTelefones,
  clienteEmails: state => state.clienteEmails,
  clienteTags: state => state.clienteTags,
  clienteProjetos: state => state.clienteProjetos,
}

const actions = {
  // Reset State
  resetStateCliente({ commit }) {
    commit('resetStateCliente');
  },
  // Cliente
  async fetchClientes({ commit }) {
    try {
      const response = await axios.get(`${baseUrl}/clientes`);
      if (response.data.length) {
        commit('setClientes', response.data);
      }
    } catch (error) {
      commit('setClientes', []);
      return error.message;
    }
  },
  async fetchClienteById({ commit }, id) {
    const response = await axios.get(`${baseUrl}/clientes/${id}`);
    if (response.data.length) {
      return response.data[0];
    } else {
      return null;
    }
  },
  async fetchClientesSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/clientes?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setClientes', response.data);
      } else {
        commit('setClientes', []);
      }
    } catch (error) {
      commit('setClientes', []);
    }
  },
  async addCliente({ commit }, cliente) {
    const response = await axios.post(`${baseUrl}/clientes`, cliente);
    cliente.IdCliente = response.data.IdCliente;
    commit('newCliente', cliente);
    return response.data.IdCliente;
  },
  async updateCliente({ commit }, updCliente) {
    await axios.put(`${baseUrl}/clientes`, updCliente);
    commit('updateCliente', updCliente);
  },
  async inativaCliente({ commit }, cliente) {
    commit('SET_LOADING', true);
    try {
      await api.put(`${baseUrl}/clientes`, cliente);
      commit('inativaCliente', cliente.IdCliente); 
      commit('SET_LOADING', false);
      return true;
    } catch (error) {
      commit('SET_LOADING', false);
      return false;
    }
  },
  async reativaCliente({ commit }, cliente) {
    commit('SET_LOADING', true);
    try {
      await api.put(`${baseUrl}/clientes`, cliente);
      commit('reativaCliente', cliente.IdCliente); 
      commit('SET_LOADING', false);
    } catch (error) {
      commit('SET_LOADING', false);
      return false;
    }
  },
  async deleteCliente({ commit }, id) {
    await axios.delete(`${baseUrl}/clientes/${id}`);
    commit('removeCliente', id);
  },

  // ENDEREÇOS

  async fetchClienteEnderecos({ commit }, idCliente) {
    try {
      const response = await axios.get(`${baseUrl}/clientes/${idCliente}/enderecos`);
      if (response.data.length) {
        commit('setClienteEnderecos', response.data);
        return response.data[0];
      } else {
        commit('setClienteEnderecos', []);
      }
    } catch (error) {
      commit('setClienteEnderecos', []);
    }
  },
  async addClienteEndereco({ commit }, endereco) {
    const response = await axios.post(`${baseUrl}/clientes/${endereco.IdCliente}/enderecos`, endereco, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    endereco.IdItem = response.data.IdItem;
    commit('newClienteEndereco', endereco);
    return response.data.IdItem;
  },
  async updateClienteEndereco({ commit }, updEndereco) {
    await axios.put(`${baseUrl}/clientes/${updEndereco.IdCliente}/enderecos/${updEndereco.IdItem}`, updEndereco, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateClienteEndereco', updEndereco);
  },
  async deleteClienteEndereco({ commit }, endereco) {
    await axios.delete(`${baseUrl}/clientes/${endereco.IdCliente}/enderecos/${endereco.IdItem}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeClienteEndereco', endereco.IdItem);
  },

  // TELEFONES

  async fetchClienteTelefones({ commit }, idCliente) {
    try {
      const response = await axios.get(`${baseUrl}/clientes/${idCliente}/telefones`);
      if (response.data.length) {
        commit('setClienteTelefones', response.data);
        return response.data[0];
      } else {
        commit('setClienteTelefones', []);
      }
    } catch (error) {
      commit('setClienteTelefones', []);
    }
  },
  async addClienteTelefone({ commit }, telefone) {
    const response = await axios.post(`${baseUrl}/clientes/${telefone.IdCliente}/telefones`, telefone, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    telefone.IdClienteTelefone = response.data.IdClienteTelefone;
    commit('newClienteTelefone', telefone);
    return response.data.IdClienteTelefone;
  },
  async updateClienteTelefone({ commit }, updTelefone) {
    await axios.put(`${baseUrl}/clientes/${updTelefone.IdCliente}/telefones/${updTelefone.IdClienteTelefone}`, updTelefone, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateClienteTelefone', updTelefone);
  },
  async deleteClienteTelefone({ commit }, telefone) {
    await axios.delete(`${baseUrl}/clientes/${telefone.IdCliente}/telefones/${telefone.IdClienteTelefone}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeClienteTelefone', telefone.IdClienteTelefone);
  },

  // EMAIL

  async fetchClienteEmails({ commit }, idCliente) {
    try {
      const response = await axios.get(`${baseUrl}/clientes/${idCliente}/emails`);
      if (response.data.length) {
        commit('setClienteEmails', response.data);
        return response.data[0];
      } else {
        commit('setClienteEmails', []);
      }
    } catch (error) {
      commit('setClienteEmails', []);
    }
  },
  async addClienteEmail({ commit }, email) {
    const response = await axios.post(`${baseUrl}/clientes/${email.IdCliente}/emails`, email, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    email.IdItem = response.data.IdItem;
    commit('newClienteEmail', email);
    return response.data.IdItem;
  },
  async updateClienteEmail({ commit }, updEmail) {
    await axios.put(`${baseUrl}/clientes/${updEmail.IdCliente}/emails/${updEmail.IdItem}`, updEmail, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateClienteEmail', updEmail);
  },
  async deleteClienteEmail({ commit }, email) {
    await axios.delete(`${baseUrl}/clientes/${email.IdCliente}/emails/${email.IdItem}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeClienteEmail', email.IdItem);
  },
  // Tags
  async fetchClienteTags({ commit }, idCliente) {
    const response = await axios.get(`${baseUrl}/clientes/${idCliente}/tags`);
    if (response.data.length) {
      commit('setClienteTags', response.data);
    } else {
      commit('setClienteTags', []);
    }
  },
  async addClienteTag({ commit }, tag) {
    try {
      const response = await axios.post(`${baseUrl}/clientes/${tag.IdCliente}/tags`, tag, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      });
      if (response) {
        commit('newClienteTag', tag);
      }
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async deleteClienteTag({ commit }, tag) {
    await axios.delete(`${baseUrl}/clientes/${tag.IdCliente}/tags/${tag.IdTag}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeClienteTag', tag.IdTag);
  },

  // Projetos

  async fetchClienteProjetos({ commit }, idCliente) {
    try {
      const response = await axios.get(`${baseUrl}/projetos?idCliente=${idCliente}`);
      if (response.data.length) {
        commit('setClienteProjetos', response.data);
        return response.data[0];
      } else {
        commit('setClienteProjetos', []);
      }
    } catch (error) {
      commit('setClienteProjetos', []);
    }
  },
}

const mutations = {
  // Reset State
  resetStateCliente: state => {
    state.clienteEnderecos = [],
    state.clienteTelefones = [],
    state.clienteEmails = [],
    state.clienteTags = [],
    state.clienteProjetos = []
  },
  // Cliente
  setClientes: (state, clientes) => state.clientes = clientes,
  newCliente: (state, cliente) => state.clientes.push(cliente),
  removeCliente: (state, id) => state.clientes = state.clientes.filter(cliente => cliente.IdCliente !== id),
  updateCliente: (state, updCliente) => {
    const index = state.clientes.findIndex(cliente => cliente.IdCliente === updCliente.IdCliente);
    if (index !== -1) {
      state.clientes.splice(index, 1, updCliente);
    }
  },
  inativaCliente: (state, idCliente) => {
    const cliente = state.clientes.find(cliente => cliente.IdCliente == idCliente);
    const index = state.clientes.findIndex(cliente => cliente.IdCliente === idCliente);

    cliente.Status = 'I';

    if (index !== -1) {
      state.clientes.splice(index, 1, cliente);
    }
  },
  reativaCliente: (state, idCliente) => {
    const cliente = state.clientes.find(cliente => cliente.IdCliente == idCliente);
    const index = state.clientes.findIndex(cliente => cliente.IdCliente === idCliente);

    cliente.Status = 'A';

    if (index !== -1) {
      state.clientes.splice(index, 1, cliente);
    }
  },
  // Endereços
  setClienteEnderecos: (state, enderecos) => state.clienteEnderecos = enderecos,
  newClienteEndereco: (state, endereco) => state.clienteEnderecos.push(endereco),
  removeClienteEndereco: (state, id) => state.clienteEnderecos = state.clienteEnderecos.filter(endereco => endereco.IdItem !== id),
  updateClienteEndereco: (state, updEndereco) => {
    const index = state.clienteEnderecos.findIndex(endereco => endereco.IdItem === updEndereco.IdItem);
    if (index !== -1) {
      state.clienteEnderecos.splice(index, 1, updEndereco);
    }
  },
  // Telefones
  setClienteTelefones: (state, telefones) => state.clienteTelefones = telefones,
  newClienteTelefone: (state, telefone) => state.clienteTelefones.push(telefone),
  removeClienteTelefone: (state, id) => state.clienteTelefones = state.clienteTelefones.filter(telefone => telefone.IdClienteTelefone !== id),
  updateClienteTelefone: (state, updTelefone) => {
    const index = state.clienteTelefones.findIndex(telefone => telefone.IdClienteTelefone === updTelefone.IdClienteTelefone);
    if (index !== -1) {
      state.clienteTelefones.splice(index, 1, updTelefone);
    }
  },
  // E-mails
  setClienteEmails: (state, emails) => state.clienteEmails = emails,
  newClienteEmail: (state, email) => state.clienteEmails.push(email),
  removeClienteEmail: (state, id) => state.clienteEmails = state.clienteEmails.filter(email => email.IdItem !== id),
  updateClienteEmail: (state, updEmail) => {
    const index = state.clienteEmails.findIndex(email => email.IdItem === updEmail.IdItem);
    if (index !== -1) {
      state.clienteEmails.splice(index, 1, updEmail);
    }
  },
  // Tags
  setClienteTags: (state, tags) => state.clienteTags = tags,
  newClienteTag: (state, tag) => state.clienteTags.push(tag),
  removeClienteTag: (state, id) => state.clienteTags = state.clienteTags.filter(tag => tag.IdTag !== id),
  // Projetos
  setClienteProjetos: (state, projetos) => state.clienteProjetos = projetos,
}

export default {
  state,
  getters,
  actions,
  mutations
}